module.exports = "<p>Documents will appear here when they are available. This will include HERO Documents, Project Documents, and Financial Documents.</p>";


//////////////////
// WEBPACK FOOTER
// ./src/app/appDetail/documents/disabledDocuments.html
// module id = 567
// module chunks = 1